import { StaffCersCupaConflictsQuery } from "generated-graphql/graphql";

export type ConflictRow = StaffCersCupaConflictsQuery["staffCersCupaConflicts"]["items"][number];

/**
 * Encamp-side display, shared by the grid's option card and anything else
 * showing the Encamp side, so the surfaces never diverge. Registry seeding
 * makes Cupa.displayName equal the linked Lepc.name for ~95% of CUPAs —
 * appending the LEPC name in that case just duplicates the string, so it is
 * shown only when it actually differs (a difference is registry drift worth
 * staff eyes). Facilities whose LEPC has no linked Cupa fall back to the bare
 * LEPC name.
 */
export function encampCupaDisplay(row: ConflictRow): string {
  const { encampCupa, encampLepc } = row;
  if (!encampCupa) return encampLepc.name;
  const base = `${encampCupa.displayName} (${encampCupa.cupaCode})`;
  if (encampLepc.name === encampCupa.displayName) return base;
  return `${base} — ${encampLepc.name}`;
}
